import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
interface ClosingProps {
  onCTAClick: () => void;
}
export function Closing({
  onCTAClick
}: ClosingProps) {
  return <section className="relative w-full overflow-hidden bg-blush-soft py-20 md:py-28" data-id="element-13">
      <div className="pointer-events-none absolute -top-20 left-1/4 w-72 h-72 rounded-full bg-sage opacity-30 blur-3xl" aria-hidden="true" data-id="element-14" />
      <div className="pointer-events-none absolute -bottom-20 right-1/4 w-72 h-72 rounded-full bg-sky-pastel opacity-40 blur-3xl" aria-hidden="true" data-id="element-15" />

      <div className="relative max-w-3xl mx-auto px-6 md:px-8 text-center" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-17">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white shadow-sm mb-8" data-id="element-18">
            <HeartIcon className="w-6 h-6 text-blush-deep" fill="currentColor" data-id="element-19" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-ink leading-relaxed mb-10 italic" data-id="element-20">
            No necesitas más suplementos caros ni más espera. Necesitas limpiar
            el camino para que tu cuerpo pueda hacer lo que naturalmente sabe
            hacer.
          </p>
          <motion.button onClick={onCTAClick} className="inline-flex items-center gap-2 bg-sage-deep text-white px-10 py-5 rounded-full font-bold text-lg shadow-lg" whileHover={{
          y: -2,
          boxShadow: '0 14px 34px rgba(148, 181, 142, 0.45)'
        }} whileTap={{
          scale: 0.98
        }} data-id="element-21">
            DESCARGAR AQUÍ
            <span aria-hidden="true" data-id="element-22">→</span>
          </motion.button>
          <p className="text-sm text-ink-muted mt-4" data-id="element-23">
            Únete a las parejas que ya empezaron su detox
          </p>
        </motion.div>
      </div>
    </section>;
}